import { Box, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";

export interface NumberCardV2Props {
  /** number to be displayed */
  number: number | string;
  /** text to be displayed */
  title: string;
  /** title is by default above, but can be placed next to the number */
  titleOrientation?: "column" | "row";
  /** icon to be displayed */
  iconSrc?: string;
  /** overwrite the background color */
  background?: string;
  titleColor?: string;
  valueTextColor?: string;
}

/** Card that displays a numeric value */
export const NumberCardV2: FC<NumberCardV2Props> = ({
  number,
  title,
  titleOrientation = "column",
  iconSrc,
  background,
  titleColor,
  valueTextColor,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Detect mobile screens

  return (
    <Box data-testid="NumberCard" sx={{ height: "100%" }}>
      <Box
        sx={{
          background: background ?? theme.palette.primary.main,
          borderRadius: "12px",
          display: "flex",
          p: 2,
          height: "100%",
          flexDirection: isMobile ? "column" : titleOrientation, // Stack title and number on mobile
          justifyContent: "start",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            alignItems: "center",
          }}
        >
          {iconSrc && (
            <Box
              component="img"
              sx={{
                background: "white",
                borderRadius: "12px",
                width: "36px",
                height: "36px",
                padding: "5px",
                mr: 2,
              }}
              src={iconSrc}
            />
          )}
          <Typography
            sx={{
              color: titleColor ?? theme.palette.secondary.contrastText,
              lineBreak: "auto",
              fontSize: "16px",
              fontWeight: 500,
              pt: 1.5,
            }}
          >
            {title}
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            flex: "1 1 100%",
          }}
        >
          <Typography
            sx={{
              color: valueTextColor ?? theme.palette.secondary.contrastText,
              fontSize: "40px",
            }}
          >
            {number}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default NumberCardV2;
